import { PureComponent } from "react";
import { Outlet } from "react-router-dom";
import './IdentityLayout.scss';
import brand from '../../../assest/images/brand/Avatar@3x.png';
import iilustration from '../../../assest/images/identity-particle/Illustration3.png';
import xPink from '../../../assest/images/identity-particle/x-pink3.png';
import xWhite from '../../../assest/images/identity-particle/x-white3.png';
import plus from '../../../assest/images/identity-particle/plus3.png';
import plusWhite from '../../../assest/images/identity-particle/plus-white3.png';

export default class IdentityLayout extends PureComponent<{}, {}> {
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }


    render = () => {
        return (
            <>
                <div className="identity-layout-area">
                    <img className="icon-float x-white" src={xWhite} width={15} height={15} />
                    <img className="icon-float plus-transparent" src={plus} width={15} height={15} />
                    <img className="icon-float plus-white" src={plusWhite} width={15} height={15} />
                    <div className="brand-area">
                        <img src={brand} width={88} height={88} />
                        <label className="title">کوچینگ تحصیلی برنده ساز</label>
                        <label className="sub-title">یه تیم نه؛ یه کوه پشتته</label>
                    </div>
                    <div className="content">
                        <Outlet />
                    </div>
                    <div className="vase-area mt-4">
                        <img className="iilustration" src={iilustration} width={104} height={117} />
                        <div style={{ clear: "both" }}></div>
                        <img className="vase-x" src={xPink} width={15} height={15} />
                        <img className="icon-float x-pink" src={xPink} width={15} height={15} />
                    </div>
                </div>
            </>
        );
    }
}